(ns nl.mediquest.be-my-coach-frontend.events
  (:require
   [ajax.core :as ajax]
   [clojure.string :as string]
   [medley.core :refer [map-vals]]
   [nl.mediquest.be-my-coach-frontend.config :refer [BACKEND_HOST]]
   [nl.mediquest.be-my-coach-frontend.db :as db]
   [nl.mediquest.ui.interceptor :refer [->gtag-event-interceptor]]
   [re-frame.core :as re-frame]))

(re-frame/reg-event-db
 ::toggle-options
 (fn [db [_ k id]]
   (update-in db [:filters k :selected]
              (fn [selected]
                (if ((set selected) id)
                  (remove #{id} selected)
                  (conj selected id))))))

(defn- clear-selected-filters
  [filters]
  (map-vals
   #(assoc % :selected '())
   filters))

(re-frame/reg-event-fx
 ::clear-filters
 (fn [cofx [_]]
   (-> cofx
       (update-in [:db :filters] clear-selected-filters)
       (assoc :fx [[:dispatch [::get-zorgverleners]]]))))

(re-frame/reg-event-db
 ::initialize-filters
 (fn [db [_ filter-defs]]
   (assoc-in db [:filters] filter-defs)))

(re-frame/reg-event-fx
 ::on-failure-get-filter-options
 (fn [_ _]
   (prn "on-failure-get-filter-options")))

(re-frame/reg-event-fx
 ::get-filter-options
 (fn [_ _]
   {:fx [[:http-xhrio
          {:method :get
           :uri (str BACKEND_HOST "/v1/filter-opties")
           :response-format (ajax/transit-response-format)
           :on-success [::initialize-filters]
           :on-failure [::on-failure-get-filter-options]}]]}))

(re-frame/reg-event-db
 ::submit-postcode
 (fn [db [_ postcode]]
   (assoc db :postcode postcode)))

(re-frame/reg-event-db
 ::initialize-db
 (constantly db/default-db))

(defn- format-filter-options
  [m k v]
  (let [options (get v :selected)]
    (if options
      (merge m {k options})
      m)))

(defn- build-api-params
  [{:keys [filters postcode] :as _db}]
  (cond-> (reduce-kv format-filter-options {} filters)
    (not (string/blank? postcode)) (assoc :postcode postcode)))

(defn- gtag-filter-event
  [{{{:keys [postcode filters]} :db} :coeffects :as _context}]
  (clj->js
   {:postcode postcode
    :filters (map-vals (comp not-empty :selected) filters)}))

(re-frame/reg-event-fx
 ::filter-zorgverleners
 [(->gtag-event-interceptor "mq_bmc_filter" gtag-filter-event)]
 (constantly
  {:fx [[:dispatch [::get-zorgverleners]]]}))

(re-frame/reg-event-fx
 ::get-zorgverleners
 (fn [{:keys [db]} [_]]
   (let [params (build-api-params db)]
     {:db db
      :http-xhrio
      {:method :get
       :uri (str BACKEND_HOST "/v1/zorgverleners")
       :params params
       :response-format (ajax/json-response-format {:keywords? true})
       :on-success [::on-success-get-zorgverleners]
       :on-failure [::on-failure-get-zorgverleners]}})))

(re-frame/reg-event-db
 ::on-success-get-zorgverleners
 (fn [db [_ zorgverleners]]
   (->> zorgverleners
        (map #(update % :type-interventie (partial map keyword)))
        (assoc db :zorgverleners))))

(re-frame/reg-event-db
 ::highlight-zorgverlener
 (fn [db [_ id]]
   (assoc db :highlighted-zorgverlener-id id)))

(re-frame/reg-event-fx
 ::on-failure-get-zorgverleners
 (fn [_ _]
   (prn "on-failure-get-zorgverleners")))

(re-frame/reg-event-db
 ::filter-panel
 (fn [db [_ open?]]
   (assoc db :filter-panel open?)))
